import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './styles/variables.css';
import './styles/utilities.css';
import './App.css';
import Navbar from './components/Navbar';
import IntroAnimation from './components/IntroAnimation';
import ErrorBoundary from './components/ErrorBoundary';
import { useIntroAnimation } from './hooks/useIntroAnimation';
import { FEATURES } from './constants/featureFlags';
import { initializeAnalytics, trackPageView } from './utils/analytics';
import { setupGlobalErrorHandlers } from './utils/errorLogging';
import Home from './pages/Home';
import Tours from './pages/Tours';
import About from './pages/About';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Success from './pages/Success';
import Error from './pages/Error';
import NotFound from './pages/NotFound';
import Footer from './components/Footer';

function AppContent() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const { introComplete, skipAnimation, handleIntroComplete } = useIntroAnimation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <div className="App">
      {isHome && (
        <IntroAnimation onComplete={handleIntroComplete} skipAnimation={skipAnimation} />
      )}
      <div className={`main-content ${introComplete ? 'visible' : ''} ${skipAnimation ? 'no-fade' : ''}`}>
        <Navbar />
        <main id="main">
          <ErrorBoundary>
            <Routes>
              {FEATURES.home && <Route path="/" element={<Home />} />}
              {FEATURES.tours && <Route path="/tours" element={<Tours />} />}
              {FEATURES.about && <Route path="/about" element={<About />} />}
              {FEATURES.contact && <Route path="/contact" element={<Contact />} />}
              {FEATURES.gallery && <Route path="/gallery" element={<Gallery />} />}
              {FEATURES.faq && <Route path="/faq" element={<FAQ />} />}
              {FEATURES.terms && <Route path="/terms" element={<Terms />} />}
              {FEATURES.privacy && <Route path="/privacy" element={<Privacy />} />}
              <Route path="/success" element={<Success />} />
              <Route path="/error" element={<Error />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ErrorBoundary>
        </main>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    initializeAnalytics();
    setupGlobalErrorHandlers();
  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;